import {ButtonContainer, StepWrapper, SubHeading, Text} from "../components/Shared";
import StyledButton from "../components/StyledButton";
import StyledSelect from "../components/StyledSelect";
import Tooltip from "../components/Tooltip";
import {solease_light_gray} from "../../constants/Colors";
import FileInput from "../components/FileInput";
import StyledTextarea from "../components/StyledTextarea";
import useForm from "../../utils/hooks/useForm";


const Step2 = ({prev, next}: { prev: () => void, next: () => void }) => {

    const {
        fields,
        setField,
        validateFields
    } = useForm(['scope12', 'constructionCalculation', 'insurerRequirements'])

    const submit = () => {
        !validateFields() && next()
    }

    return (
        <StepWrapper>
            <SubHeading>Verzekeringseisen</SubHeading>

            <Text>Aangezien de offerteaanvraag zakelijk is, kan het voorkomen dat jouw verzekeraar strenge eisen stelt met betrekking tot zonnepanelen. Om ervoor te zorgen dat we met alles rekening houden, zouden we graag willen weten welke eisen jouw verzekeraar hanteert.</Text>

            <StyledSelect
                onChange={(value)=>setField({key: 'scope12', value})}
                error={fields['scope12'].error}
                additionalContent={<Tooltip
                    text={'Wat is een Scope 12-keuring?'}
                    description={'Een Scope 12-keuring is een elektrische inspectie van de installatie vanaf de zonnepanelen tot aan het koppelpunt met de netbeheerder. In deze keuring wordt er door een inspecteur gekeken naar brandrisico’s en de elektrische veiligheid.'}/>}
                label={'Is het vereist om een Scope 12-keuring uit te laten voeren? '}/>

            <StyledSelect
                onChange={(value)=>setField({key: 'constructionCalculation', value})}
                error={fields['constructionCalculation'].error}
                additionalContent={<Tooltip
                    text={'Wat is een constructieberekening?'}
                    description={'Een constructieberekening wordt gemaakt door een constructeur en bevat een berekening van alle dragende delen van een constructie. Hierbij wordt er gekeken hoeveel het dak belast kan worden. Indien dit een vereiste is van je verzekeraar zal deze keuring gedaan moeten worden vóór de installatie. Mocht je hier vragen over krijgen, kan je contact opnemen met ons!'}/>}
                label={'Is het vereist om een constructieberekening uit te laten voeren?'}/>
            <FileInput />

            <StyledSelect
                onChange={(value)=>setField({key: 'insurerRequirements', value})}
                error={fields['insurerRequirements'].error}
                hasInput
                additionalContent={
                <Text small style={{color: solease_light_gray}}>
                    Denk aan specifieke technische eisen, zoals merk/type zonnepaneel of omvormer.</Text>}
                label={'Zijn er overige eisen bekend vanuit de verzekeraar?'}/>
            <FileInput />
            
            <StyledTextarea label={'Overige opmerkingen of toelichting'}/>


            <ButtonContainer>
                <StyledButton
                    secondary
                    onClick={() => prev()}
                    label={'Vorige \nstap'}/>

                <StyledButton
                    onClick={() => submit()}
                    label={'VERSTUREN'}/>
            </ButtonContainer>
        </StepWrapper>
    )
}

export default Step2
